export default {
  name: 'marking--productionTypeInput',
};